// extracted by mini-css-extract-plugin
export default {"balance":"FundDistributionFooter_balance__czZd-","balance-amount":"FundDistributionFooter_balance-amount__+VlGQ","balance-icon":"FundDistributionFooter_balance-icon__o1a18"};